import Vue from 'vue'

import { titleCase, ensureHttp, pluralize } from '@/lib/utils'

export default function ({ $config }) {
  Vue.filter('currency', function (value) {
    if (typeof value !== 'number') {
      return value
    }
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    })
    return formatter.format(value)
  })

  Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
  })

  Vue.filter('lowercase', function (value) {
    if (!value) return ''
    return value.toLowerCase()
  })

  Vue.filter('lowerCase', function (value) {
    if (!value) return ''
    return value.toLowerCase()
  })

  Vue.filter('titleCase', function (value) {
    if (!value) return ''
    return titleCase(value)
  })

  Vue.filter('pluralize', (amount, word) => pluralize(amount, word))

  Vue.filter('absoluteURL', function (value) {
    if (!value) return ''
    return $config.apiUrl + value
  })

  Vue.filter('ensureHttp', ensureHttp)
}
